import * as stateMachine from 'rwwa-rx-state-machine'

export const open = stateMachine.createIntent('OPEN MODAL')
export const close = stateMachine.createIntent('CLOSE MODAL')
